import React, { useState, useEffect } from 'react';
import './InstallPWA.css';

/**
 * Component that provides a user-friendly button to install the PWA
 * Appears only when the app is installable and not already installed
 */
const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptEvent, setPromptEvent] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    // Check if the app is already installed
    if (window.matchMedia('(display-mode: standalone)').matches || 
        window.navigator.standalone === true) {
      setIsInstalled(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptEvent(e);
      setShowInstallPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = () => {
    if (!promptEvent) {
      console.log('Install prompt not available');
      return;
    }
    
    // Show the install prompt
    promptEvent.prompt();
    
    // Wait for the user to respond to the prompt
    promptEvent.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
        setShowInstallPrompt(false);
      } else {
        console.log('User dismissed the install prompt');
      }
      
      // Clear the saved prompt since it can't be used twice
      setPromptEvent(null);
    });
  };

  const handleDismissClick = () => {
    setShowInstallPrompt(false);
  };

  // Only show install button if:
  // 1. Browser supports PWA
  // 2. App is not already installed
  // 3. User hasn't dismissed the prompt
  if (!supportsPWA || isInstalled || !showInstallPrompt) {
    return null;
  }

  return (
    <div className="pwa-install-container">
      <div className="pwa-install-prompt">
        <div className="pwa-install-content">
          <div className="pwa-install-icon">
            <img src="/images/logo/logo-192.png" alt="Unissn" />
          </div>
          <div className="pwa-install-message">
            <h3>Install Unissn App</h3>
            <p>Install this app on your device for quick and easy access when you're on the go.</p>
          </div>
        </div>
        <div className="pwa-install-actions">
          <button className="pwa-install-button" onClick={handleInstallClick}>
            Install
          </button>
          <button className="pwa-dismiss-button" onClick={handleDismissClick}>
            Not Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPWA;
